import React from "react";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import Rating from "./Rating";

const Product = ({ product, categoryDiscounts = [] }) => {
  // Helper to get discount percent by category
  const getCategoryDiscount = (category) => {
    const discountObj = categoryDiscounts.find((d) => d.category === category);
    return discountObj ? discountObj.percent : 0;
  };

  const discountPercent = getCategoryDiscount(product.category);
  const discountedPrice = discountPercent
    ? (product.price * (1 - discountPercent / 100)).toFixed(2)
    : product.price;

  // Product.js
return (
  <Card
        className="product-card p-0 rounded-0"

    style={{ backgroundColor: "transparent" ,margin:"20px 20px"}}
  >
    <Link to={`/product/${product._id}`}>
      {discountPercent > 0 && (
        <span
          style={{
            padding: "2px",
            position: "absolute",
            top: 3,
            backgroundColor: "#cee0bdff",
            color: "#205c40ff",
            fontSize: "0.8rem",
            zIndex: 10,
          }}
        >
          {discountPercent}% OFF
        </span>
      )}
      <Card.Img
  className="product-image border-0 shadow-none p-0 rounded-0"
  src={product.image}
  variant="top"
/>

    </Link>

    <Card.Body className="p-0 mt-2" style={{ backgroundColor: "transparent" }}>
      <Link to={`/product/${product._id}`}>
        <Card.Title
          as="div"
          style={{ fontSize:"22px", fontWeight:500 , color: "#2b2b2bc0"}}
        >
          {product.name}
        </Card.Title>
      </Link>

      {discountPercent > 0 ? (
        <Card.Text as="h6" className="mb-0">
          <span
            style={{
              textDecoration: "line-through",
              color: "#999",
              marginRight: "8px",
            }}
          >
            Rs. {Math.round(product.price)}
          </span>
          <span
            style={{
              fontSize: "16px",
              padding: "0px 5px",
              color: "#616161ff",
              fontWeight: 300,
            }}
          >
            Rs. {Math.round(discountedPrice)}
          </span>
        </Card.Text>
      ) : (
        <Card.Text
          as="h6"
          className="mb-0"
          style={{
            fontSize: "16px",
            padding: "0px 5px",
            color: "#616161ff",
            fontWeight: 300,
          }}
        >
          Rs. {Math.round(product.price)}
        </Card.Text>
      )}
    </Card.Body>
  </Card>
);

};

export default Product;
